export default __webpack_public_path__ + "static/media/necromanceraction.4f853e49.png";